module.exports = __webpack_public_path__ + "02_medium_brown.8e32ce38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_medium_brown.png
// module id = 8yor
// module chunks = 0